export default function PlayersSelector({
  label,
  athletes,
  selected,
  onChange,
  isHome = true,
}) {
  const toggle = (number) => {
    const exists = selected.includes(number);
    if (exists) {
      onChange(selected.filter((n) => n !== number));
    } else if (selected.length < 7) {
      onChange([...selected, number]);
    }
  };

  const selectedColor = isHome ? "bg-blue-500" : "bg-red-500";

  const firstName = (fullName) => fullName.split(" ")[0];

  return (
    <div>
      <h2 className="font-semibold">{label}</h2>
      <div className="grid grid-cols-3 gap-2">
        {athletes.map((a) => (
          <button
            key={a.number}
            onClick={() => toggle(a.number)}
            className={`border px-2 py-1 rounded ${
              selected.includes(a.number)
                ? `${selectedColor} text-white`
                : "bg-gray-100"
            }`}
          >
            #{a.number} {firstName(a.name)} ({a.function})
          </button>
        ))}
      </div>

      <div className="mt-2 text-xs text-gray-500">
        Escalação:
        {selected.map((num, idx) => {
          const athlete = athletes.find((a) => a.number === num);
          return (
            <div key={num}>
              {idx + 1}. #{num} {athlete ? firstName(athlete.name) : ""} (
              {athlete?.function})
            </div>
          );
        })}
      </div>
    </div>
  );
}
